module.exports = __webpack_public_path__ + "img/p_sz_17.5ed43ca4.svg";